import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { DatiBilancioBisWarningsService } from './warnings/dati-bilancio-bis.warnings';
import { DatiBilancioBisFieldValidators } from './validators/dati-bilancio-bis.field-validators';

@NgModule({
    declarations: [],
    imports: [CommonModule, ReactiveFormsModule],
    providers: [DatiBilancioBisWarningsService, DatiBilancioBisFieldValidators],
})
export class DatiBilancioBisFormModule {}
